import { LogOut, ShieldCheck } from "lucide-react";
import { formatDateTime } from "@/lib/utils";
import { useAuthStore } from "@/stores/authStore";
import { Button } from "@/components/ui/button";
import {
  Badge,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/primitives";
import { PageHeader } from "@/components/data/toolbar";

// ════════════════════════════════════════════════════════════════════════
//  Admin Profile & Account Details
// ════════════════════════════════════════════════════════════════════════

export const ProfilePage = () => {
  const { admin, roleKey, logout } = useAuthStore();

  return (
    <div className="max-w-2xl space-y-6">
      <PageHeader
        title="Admin Profile"
        description="Your administrator account details and active session."
      />

      <Card className="border-border">
        <CardHeader className="flex flex-row items-center justify-between pb-4">
          <div className="space-y-1">
            <CardTitle className="text-lg">Account Information</CardTitle>
            <CardDescription>
              Details associated with this authenticated administrator session.
            </CardDescription>
          </div>
          <span className="grid h-10 w-10 place-items-center rounded-xl bg-primary/10 text-primary">
            <ShieldCheck className="h-5 w-5" />
          </span>
        </CardHeader>
        <CardContent>
          <ul className="divide-y divide-border text-sm">
            <li className="flex justify-between py-3">
              <span className="text-muted-foreground font-medium">Name</span>
              <span className="font-semibold text-foreground">{admin?.name || "Administrator"}</span>
            </li>
            <li className="flex justify-between py-3">
              <span className="text-muted-foreground font-medium">Mobile Number</span>
              <span className="font-mono text-foreground">{admin?.phone ? `+91 ${admin.phone}` : "—"}</span>
            </li>
            <li className="flex justify-between py-3">
              <span className="text-muted-foreground font-medium">Email</span>
              <span className="text-foreground">{admin?.email || "—"}</span>
            </li>
            <li className="flex justify-between py-3">
              <span className="text-muted-foreground font-medium">Access Role</span>
              <Badge variant="default" className="capitalize">
                {roleKey || "Administrator"}
              </Badge>
            </li>
            {admin?.last_login_at && (
              <li className="flex justify-between py-3">
                <span className="text-muted-foreground font-medium">Last Sign-In</span>
                <span>{formatDateTime(admin.last_login_at)}</span>
              </li>
            )}
          </ul>
        </CardContent>
      </Card>

      <Card className="border-border bg-surface/40">
        <CardHeader className="pb-3">
          <CardTitle className="text-base">Session Management</CardTitle>
          <CardDescription>
            Securely sign out of the GetPet Admin Dashboard.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button
            variant="destructive"
            className="gap-2"
            onClick={() => void logout()}
          >
            <LogOut className="h-4 w-4" />
            Sign Out of Admin Portal
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};
